module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ext-form', {
    attrs: {
      "formData": _vm.formData,
      "submitProxy": _vm.submitProxy,
      "loadProxy": _vm.loadProxy,
      "extraData": _vm.extraData
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('entity')
    },
    attrs: {
      "label": "Сущность",
      "feedback": _vm.errors.first('entity')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.entity),
      expression: "formData.entity"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "entity"
    },
    domProps: {
      "value": (_vm.formData.entity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.entity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.formData.create),
      callback: function($$v) {
        _vm.formData.create = $$v
      },
      expression: "formData.create"
    }
  }, [_vm._v("\n    Создание\n  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.formData.read),
      callback: function($$v) {
        _vm.formData.read = $$v
      },
      expression: "formData.read"
    }
  }, [_vm._v("\n    Чтение\n  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.formData.update),
      callback: function($$v) {
        _vm.formData.update = $$v
      },
      expression: "formData.update"
    }
  }, [_vm._v("\n    Обновление\n  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.formData.delete),
      callback: function($$v) {
        _vm.formData.delete = $$v
      },
      expression: "formData.delete"
    }
  }, [_vm._v("\n    Удаление\n  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.formData.owner),
      callback: function($$v) {
        _vm.formData.owner = $$v
      },
      expression: "formData.owner"
    }
  }, [_vm._v("\n    Изменение владельцем\n  ")]), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6c779b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/RightForm.vue
// module id = 241
// module chunks = 1